import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/dtrpg-logo-small.png'
import _imports_1 from '../../assets/rpg-trader-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-a999fad8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "release-body" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "release-top" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Mercs, Mages and Monsters a TTRPG")
], -1))
const _hoisted_3 = { class: "release-bottom" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<h3 data-v-a999fad8>Find Mercs, Mages and Monsters at our storefronts:</h3><div class=\"store-logos\" data-v-a999fad8><div class=\"store-slot\" data-v-a999fad8><a class=\"store-link\" target=\"_blank\" rel=\"noopener noreferrer\" aria-label=\"Open the Bad Toad Games DriveThruRPG store\" href=\"https://www.drivethrurpg.com/en/publisher/29656/bad-toad-games-llc/category/51783/mercs-mages-and-monsters\" data-v-a999fad8><img class=\"store-logo store-logo--dtrpg\" src=\"" + _imports_0 + "\" alt=\"DriveThruRPG\" data-v-a999fad8></a></div><div class=\"store-slot\" data-v-a999fad8><a class=\"store-link\" target=\"_blank\" rel=\"noopener noreferrer\" aria-label=\"Open the Bad Toad Games RPG Trader store\" href=\"https://rpg-trader.com/creator/171/bad-toad-games\" data-v-a999fad8><img class=\"store-logo store-logo--rpgt\" src=\"" + _imports_1 + "\" alt=\"RPG Trader\" data-v-a999fad8></a></div></div>", 2)
const _hoisted_6 = { class: "features" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Interviews & Podcasts", -1))
const _hoisted_8 = { class: "features-scroll" }
const _hoisted_9 = ["href", "aria-label"]
const _hoisted_10 = { class: "feature-title" }
const _hoisted_11 = {
  key: 0,
  class: "feature-source"
}
const _hoisted_12 = {
  key: 0,
  class: "features-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (feature) => {
            return (_openBlock(), _createElementBlock("a", {
              key: feature.title,
              class: "feature-card",
              href: feature.url,
              target: "_blank",
              rel: "noopener noreferrer",
              "aria-label": `Open ${feature.title}`
            }, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(feature.title), 1),
              (feature.source)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(feature.source), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_fa, {
                class: "feature-icon",
                icon: "arrow-up-right-from-square"
              })
            ], 8, _hoisted_9))
          }), 128)),
          (_ctx.features.length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_12, " More coming soon… "))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}